<template>
    <div id="app">
        <el-container v-if="list&&list.length>0">

            <el-main>
                <el-row>
                    <el-col :span="6" v-for="(item, index) in currentPageData" :key="index">
                        <el-card class="item" shadow="never">
                            <div class="card_boady">
                                <!-- 动态绑定图片路径并设置默认值 -->
                                <img :src="item.ImagePath || require('@/assets/images/img_noimg.png')" class="item-image" alt="商品图片">
                                <div class="card-text-container">
                                    <div class="card-text-title">
                                        <h2>{{ item.ItemName }}</h2>
                                        <p style="color: red;font-weight: 900;" v-if="item.BeginTime&&item.EndTime">时段特价：{{ item.BeginTime }}-{{ item.EndTime }}</p>
                                    </div>
                                    <div class="card-text-price">
                                        <div class="card-text-memo">{{item.Memo}}</div>


                                        <span style="font-size: 12vh;">{{ formatPrice(item.SpecPrice).integerPart
                                            }}</span>

                                        <span style="font-size: 8vh;">.{{ formatPrice(item.SpecPrice).decimalPart
                                            }}<span style="font-size: 2.0vh; font-weight: 400;">元{{ item.Unit?'/'+item.Unit:'' }}</span></span>

                                    </div>
                                </div>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
            </el-main>
        </el-container>
        <el-empty :image-size="200" v-else></el-empty>
    </div>
</template>

<script>
import {
    getitemspecprice
} from '@/api/Item.js';
export default {
    name: 'ItemPromotion',
    components: {
    },
    props: {
        PSmartScreenId: {
            type: Number,
            default: 0
        }
    },

    data() {
        return {
            SmartScreenId: 0,
            list: [],
            currentPage: 1,
            pageSize: 16,
            currentPageData: [],
            timer: null, // 添加轮播定时器

            interval: null // 添加轮播定时器
        }
    },
    watch: {
        PSmartScreenId: {
            handler(newVal, oldVal) {
                console.log(newVal, oldVal);
                this.SmartScreenId = newVal;
                this.getitemspecprice();
            },
            immediate: true
        }
    },

    async mounted() {
        //接收路由参数
        this.SmartScreenId = Number(this.$route.query.SmartScreenId) || this.PSmartScreenId;
        await this.getitemspecprice();
        this.timer = setTimeout(() => {
            this.getitemspecprice();
        }, 60000);

        if (this.list.length > 0) {

            // 启动轮播定时器（每8秒切换一页）
            this.interval = setInterval(() => {
                const totalPages = this.getTotalPages();
                this.currentPage = this.currentPage % totalPages + 1;
                // 更新当前页数据
                this.currentPageData = this.getPageData();
            }, 8000);
        }
    },
    beforeUnmount() {
        // 清除定时器，防止内存泄漏
        clearInterval(this.interval);
        clearTimeout(this.timer);
    },
    methods: {
        async getitemspecprice() {
            if (!this.SmartScreenId||this.SmartScreenId<=0) {
                return;
            }

            let res = await getitemspecprice({
                SmartScreenId: this.SmartScreenId,
            })
            if (res.Code === 0) {
                this.list = res.Data;
                // 数据加载完成后初始化第一页数据
                this.currentPageData = this.getPageData();
            }
        },
        // 新增：获取当前页数据
        getPageData() {
            const startIndex = (this.currentPage - 1) * this.pageSize;
            const endIndex = startIndex + this.pageSize;
            return this.list.slice(startIndex, endIndex);
        },
        // 计算总页数
        getTotalPages() {
            return Math.ceil(this.list.length / this.pageSize);
        },
        // 计算总商品数
        totalItems() {
            return this.list.length;
        },
        formatPrice(price) {
            // 确保价格为数字并保留两位小数
            const formattedPrice = Number(price).toFixed(2);
            // 拆分整数和小数部分
            const [integerPart, decimalPart] = formattedPrice.split('.');
            return {
                integerPart,
                decimalPart
            };
        }
    }


}

</script>

<style>
body {
    font-family: fantasy;
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0
}

strong {
    color: red;
    font-size: 4.8vw;
    background: transparent;
}

.item {
    border-radius: 4px;
    border: 1px solid red !important;
    background-color: #FFF;
    overflow: hidden;
    color: #303133;
    transition: .3s;
    height: 24vh;
}

.el-card__body {
    padding: 0px !important;
    width: 100%;
    height: 100%;
}

.cardboady {
    display: flex;
    flex-direction: row;
    /* align-items: center;
    justify-content: center; */
}

.image-container {
    flex: 0.6;
    width: 12vw;
    height: 12vw;

    .image {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

.text-container {
    flex: 0.4;
    padding: 10px;
}

.card_boady {
    display: flex;
    flex-direction: column;
    /* 移除背景图属性 */
    /* background-image: url('@/assets/images/img_noimg.png'); */
    /*靠左*/
    background-position: left;
    background-size: 25vh 24vh;
    background-repeat: no-repeat;
    width: 100%;
    height: 100%;
    padding-bottom: 1.5vh;
    padding-top: 1.5vh;
    position: relative; /* 添加相对定位作为图片容器 */
}

/* 添加图片样式 */
.item-image {
    position: absolute;
    left: 0;
    top: 0;
    width: 25vh;
    height: 24vh;
    object-fit: cover;
}

.card-text-container {
    text-align: center;
}

.card-text-title {
    padding-left: 12vw; /* 保持原有左内边距，确保文字不被图片遮挡 */
    text-align: center;
    height: 8vh;
        position: relative; /* 添加相对定位使z-index生效 */
    z-index: 100; /* 保持现有z-index确保层级高于图片 */
}

.card-text-price {
    display: flex;
    justify-content: right;
    align-items: center;
    color: red;
    font-weight: 900;
    padding-right: 20px;
    position: relative; /* 添加相对定位使z-index生效 */
    z-index: 100; /* 保持现有z-index确保层级高于图片 */
}

.card-text-memo {
    position: relative;
    right: -10vw;
    width: 4vw;
    top: -6.8vh;
    font-size: 2vh;
        position: relative; /* 添加相对定位使z-index生效 */
    z-index: 100; /* 保持现有z-index确保层级高于图片 */
}
</style>